import React__default from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { getAttributeLabel, getEyeLabel } from '../../../../../utils.js';
import { LabelWithTooltip } from '../LabelWithTooltip/LabelWithTooltip.js';
import { SelectWrapper } from '../SelectWrapper/SelectWrapper.js';

const ReadOnlyElement = ({ attribute , value , id , className  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React__default.createElement(SelectWrapper, {
        key: attribute,
        className: classnames('contact-lens-readonly', className)
    }, /*#__PURE__*/ React__default.createElement(LabelWithTooltip, {
        type: attribute,
        id: id
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "contact-lens-readonly__value",
        "aria-label": `${getAttributeLabel(intl, attribute)} ${getEyeLabel(intl, id)} ${value}`,
        "data-t": `prescription-${attribute}`
    }, value));
};

export { ReadOnlyElement };
//# sourceMappingURL=ReadOnlyElement.js.map
